import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Input, Table, Space, Skeleton, DatePicker, Drawer, Badge  } from 'antd';
import { LinkOutlined, UserOutlined, CheckCircleOutlined, SearchOutlined,SnippetsOutlined,FieldNumberOutlined , InfoCircleOutlined, DollarOutlined, DollarCircleOutlined, CreditCardOutlined } from '@ant-design/icons';
import { CaretRightOutlined } from "@ant-design/icons";
import moment from 'moment';
import LayoutDetail from '../Layout/'
import useWindowDimensions from '../../hooks/windowDimensionsHook'
import { useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';

const { Search } = Input;

function Checkout({ pagamentos, asyncBuscarPagamentos }) {

    const { height, width } = useWindowDimensions();
    const location = useLocation();
    const [data, setData] = useState([]);
    const [dataFixa, setDataFixa] = useState([]);
    const [numeroRequisicao, setNumeroRequisicao] = useState(0)
    const [loading, setLoading] = useState(false);
    const [DataFinalPeriodoConsulta, setDataFinal] = useState(moment(Date.now()).format('YYYY-MM-DD'));
    const [DataInicioPeriodoConsulta, setDataInicial] = useState(moment(Date.now()).format('YYYY-MM-DD'));
    const [filial, setFilial] = useState(0);
    const [detalhes, showDetalhes] = useState(false)
    const [habilitarFiltros, showFiltros] = useState(false)
    const [itemSelecionado, setNFSSelecionada] = useState(undefined)
    const [detalhesRequisicoes, setDetalhesRequisicoes] = useState(false)
    const [token] = useState(location.state.detail.token);
    const [searchedColumn, setSearchedColumn] = useState('');
    const [searchText, setSearchText] = useState('');

    const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];

    function onClose() {
        console.log('close')
        showDetalhes(false);
    }

    function exibirInformacoes(item) {
        showDetalhes(true);
        setNFSSelecionada(item);
        console.log('item selecionado:', item)
    }

    async function handleDataInicial(date, dateString) {
        console.log('Gravando data inicial...', date.format('YYYY-MM-DD'))
        await setDataInicial(date.format('YYYY-MM-DD'));
        showFiltros(true)
    }

    async function exibirDetalhesRequisicoes(){
        setDetalhesRequisicoes(true);
    }
    async function esconderDetalhesRequisicoes(){
        setDetalhesRequisicoes(false);
    }
    async function handleDataFinal(date, dateString) {
        console.log('Gravando data final...', date.format('YYYY-MM-DD'))
        await setDataFinal(date.format('YYYY-MM-DD'));
        showFiltros(true);
    }
    useEffect(() => {
        buscar();
    }, []);

    useEffect(() => {
        setData(pagamentos);
    }, [pagamentos]);

    async function buscar() {
        setLoading(true);
        const pagina = 0;
        const registros = 50;
        console.log('[ :::: DADOS ENVIADOS LISTAR PAGAMENTOS: ]', { dados: { filial, numeroRequisicao, DataInicioPeriodoConsulta, DataFinalPeriodoConsulta, pagina, registros }})
        var dadosConsulta = { dados: { filial, numeroRequisicao, DataInicioPeriodoConsulta, DataFinalPeriodoConsulta, pagina, registros }, token: token };
        await asyncBuscarPagamentos(dadosConsulta)
        setLoading(false);
    }

    


    const filtrarColuna = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Buscar`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => buscarTextoGrid(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => buscarTextoGrid(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
              </Button>
                    <Button onClick={() => resetarBusca(clearFilters)} size="small" style={{ width: 90 }}>
                        Limpar
              </Button>
                    
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {

        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                    text
                ),
    });

    const buscarTextoGrid = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const resetarBusca = clearFilters => {
        clearFilters();
        setSearchText('');
        setSearchedColumn('');
    };
    const columns = [
        {
            dataIndex: 'Status',
            width: 5,
            render: text =>
                text === "Transação Autorizada" ?
                    (
                        <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    ) : (
                        text === "Aguardando Pagamento" ? (
                            <CheckCircleOutlined style={{ color: 'yellow' }} />
                        ) : (
                                <CheckCircleOutlined style={{ color: 'red' }} />
                            )
                    )
        },
        {
            title: 'Cliente',
            dataIndex: 'Cliente',
            ...filtrarColuna('Cliente')
        },
        {
            title: 'Valor',
            dataIndex: 'Valor',
            width: 150,
            ...filtrarColuna('Valor')
        },
        {
            title: 'Data do Pagamento',
            dataIndex: 'DataPagamento',
            width: 200,
            ...filtrarColuna('DataPagamento')
        },
        {
            title: 'CF',
            dataIndex: 'CF',
            width: 150,
        },
        {
            title: 'Status',
            dataIndex: 'Status',
            width: 150,
        },
        {
            title: 'Detalhes',
            key: 'action',
            render: (text, record) => <Button onClick={() => exibirInformacoes(record)}>Detalhes</Button>,
        },
    ];
    return (
        <LayoutDetail  breadCrumbs={['Checkout', 'Link de pagamento']}>
            <Drawer
                title="Detalhes da nota"
                closable={true}
                onClose={onClose}
                width={520}
                bodyStyle={{ backgroundColor: '#fff' }}
                visible={detalhes}
            >
                {
                    itemSelecionado != undefined ? (
                        <>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <UserOutlined /> </Col>
                                <Col span={5} > <p>Cliente:</p></Col>
                                <Col span={14}> {itemSelecionado.Cliente}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <SnippetsOutlined /> </Col>
                                <Col span={5} > <p>Cupom Fiscal:</p></Col>
                                <Col span={14}> {itemSelecionado.CupomFiscal}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <LinkOutlined /> </Col>
                                <Col span={5} > <p>Link:</p></Col>
                                <Col span={14}> <a href={itemSelecionado.Link}>Acessar</a></Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <CreditCardOutlined /> </Col>
                                <Col span={5} > <p>Parcelas:</p></Col>
                                <Col span={14}> {itemSelecionado.Parcelas}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <InfoCircleOutlined /> </Col>
                                <Col span={5} > <p>Status:</p></Col>
                                <Col span={14}> {itemSelecionado.Status}</Col>
                            </Row>
                            {
                                itemSelecionado.Requisicoes.length > 0 ? (
                                <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                    <Col span={1}> <LinkOutlined /> </Col>
                                    <Col span={5} > <p>Requisições:</p></Col>
                                    <Col span={14}> <Button type='link' onClick={exibirDetalhesRequisicoes}>Detalhes</Button> <Badge count={ itemSelecionado.Requisicoes.length}></Badge></Col>
                                </Row>
                                ):null
                            }
                             {
                                itemSelecionado.Produtos.length > 0 ? (
                                <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                    <Col span={1}> <LinkOutlined /> </Col>
                                    <Col span={5} > <p>Produtos:</p></Col>
                                    <Col span={14}> <Button type='link' onClick={exibirDetalhesRequisicoes}>Detalhes</Button> <Badge count={ itemSelecionado.Produtos.length}></Badge></Col>
                                </Row>
                                ):null
                            }
                           
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <DollarCircleOutlined /> </Col>
                                <Col span={5} > <p>Valor Formula:</p></Col>
                                <Col span={14}> {itemSelecionado.ValorFormula}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <DollarCircleOutlined /> </Col>
                                <Col span={5} > <p>Valor Formula:</p></Col>
                                <Col span={14}> {itemSelecionado.ValorFormula}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <DollarCircleOutlined /> </Col>
                                <Col span={5} > <p>Valor Frete:</p></Col>
                                <Col span={14}> {itemSelecionado.ValorFrete}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <DollarCircleOutlined /> </Col>
                                <Col span={5} > <p>Valor Formula:</p></Col>
                                <Col span={14}> {itemSelecionado.ValorFormula}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <DollarCircleOutlined /> </Col>
                                <Col span={5} > <p>Valor Liquido:</p></Col>
                                <Col span={14}> {itemSelecionado.ValorLiquidoFormula}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <DollarCircleOutlined /> </Col>
                                <Col span={5} > <p>Valor Liquido:</p></Col>
                                <Col span={14}> {itemSelecionado.ValorLiquidoFormula}</Col>
                            </Row>
                            <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                <Col span={1}> <DollarOutlined /> </Col>
                                <Col span={5} > <p style={{ fontWeight: 'bold' }}>Valor Total:</p></Col>
                                <Col span={14} style={{ fontWeight: 'bold' }}> {itemSelecionado.ValorTotal}</Col>
                            </Row>
                            <Drawer
                                title="Requisições"
                                closable={true}
                                onClose={esconderDetalhesRequisicoes}
                                width={300}
                                bodyStyle={{ backgroundColor: '#fff' }}
                                visible={detalhesRequisicoes}>
                                <>
                                    {
                                        itemSelecionado.Requisicoes.map(item => {
                                            return <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                                <Col span={2}> <FieldNumberOutlined  /> </Col>
                                                <Col span={5} > <p style={{ fontWeight: 'bold' }}>Código:</p></Col>
                                                <Col span={14} style={{ fontWeight: 'bold' }}> {item}</Col>
                                            </Row>
                                        })
                                    }
                                    {
                                        itemSelecionado.Produtos.map(item => {
                                            return <Row style={{ borderBottom: '1px dotted #ccc', padding: 0, paddingTop: 10 }}>
                                                <Col span={2}> <DollarOutlined /> </Col>
                                                <Col span={5} > <p style={{ fontWeight: 'bold' }}>Nome:</p></Col>
                                                <Col span={14} style={{ fontWeight: 'bold' }}> {item}</Col>
                                            </Row>
                                        })
                                    }

                                </>
                            </Drawer>

                        </>
                    ) : null
                }


            </Drawer>
            <Row >
                <Col span={12}>Escolha uma das filiais para consultar</Col>
            </Row>
            <Row >
                <Col xs={24} sm={24} md={3} lg={3} xl={3} style={{ marginRight: 10, paddingTop: 5 }}>
                    <DatePicker onChange={(date, dateString) => handleDataInicial(date, dateString)} style={{ width: '100%' }} defaultValue={moment()} format={dateFormatList} />
                </Col>
                <Col xs={24} sm={24} md={3} lg={3} xl={3} style={{ paddingTop: 5 }}>
                    <DatePicker onChange={(date, dateString) => handleDataFinal(date, dateString)} style={{ width: '100%' }} defaultValue={moment()} format={dateFormatList} />
                </Col>
                <Col xs={24} sm={24} md={6} lg={6} xl={6} style={{ marginLeft: 10, paddingTop: 5 }}>
                    <Input style={{ width: '100%' }} onChange={e => setNumeroRequisicao(e.target.value)} placeholder="Número da Requisição" prefix={<SnippetsOutlined />} />
                </Col>
            </Row>
            {
                habilitarFiltros ? (
                    <>
                        <Row style={{ marginTop: 10, marginBottom: 10 }}>
                            <Col style={{ paddingRight: 10 }} xs={24} sm={24} md={3} lg={3} xl={3}>
                                <Button onClick={() => setFilial(1)} style={{ width: '100%', marginRight: 10 }} >
                                    01 - MATRIZ
                        </Button>
                            </Col>
                            <Col style={{ paddingRight: 10 }} xs={24} sm={24} md={3} lg={3} xl={3}>
                                <Button onClick={() => setFilial(4)} style={{ width: '100%', marginRight: 10 }} >
                                    04 - HARMONY
                        </Button>
                            </Col>
                            <Col style={{ paddingRight: 10 }} xs={24} sm={24} md={3} lg={3} xl={3}>
                                <Button onClick={() => setFilial(30)} style={{ width: '100%', marginRight: 10 }} >
                                    30 - CENTRAL
                        </Button>
                            </Col>
                            <Col style={{ paddingRight: 10 }} xs={24} sm={24} md={3} lg={3} xl={3}>
                                <Button onClick={() => setFilial(33)} style={{ width: '100%', }}  >
                                    33 - RIO MAR
                        </Button>
                            </Col>
                        </Row>
                        <Row style={{ paddingBottom:10}}>
                            <Col>
                                <Button onClick={() => buscar()}>Buscar</Button>
                            </Col>
                        </Row>

                   
                    </>
                ) : null
            }


            <Row style={{ backgroundColor: '#eee'}}>
                <Col span={24}>
                    {
                        loading == false ? (
                            <Table columns={columns} dataSource={data.itens} pagination={{ pageSize: 10 }} />
                        ) : (
                                <Skeleton loading />
                            )
                    }
                </Col>
            </Row>
        </LayoutDetail>

    );
}

const mapState = (state) => ({
    pagamentos: state.checkout.pagamentos,
})
const mapDispatch = (dispatch) => ({
    asyncBuscarPagamentos: payload => dispatch.checkout.asyncBuscarPagamentos(payload),
})

export default connect(mapState, mapDispatch)(Checkout)